import { ResetUsernameRequestPage } from "./ResetUsernameRequestPage";

export function NewUserRequestPage(){
    return <ResetUsernameRequestPage newUser />
}